<div class="details">
  @if (sharedStateService.board) {
  <form [formGroup]="boardForm">
    <div class="card-crud" mat-dialog-content>
      @if (this.sharedStateService.card) {
      <div class="verytop">
        @if (this.sharedStateService.card.dueDate) {
        <div class="info-item due-date" [ngClass]="dueDateStatus">
          <mat-icon class="info-icon">event</mat-icon>
          <span>{{ dueDateText }}</span>
        </div>
        }
        @if (this.sharedStateService.card.reporter && getReporterName(this.sharedStateService.card.reporter)) {
        <div class="info-item reporter-info">
          <mat-icon class="info-icon">person</mat-icon>
          <span>Reported by {{ getReporterName(this.sharedStateService.card.reporter) }}</span>
        </div>
        }
        @if (this.sharedStateService.card.createdAt) {
        <div class="info-item created">
          <mat-icon class="info-icon">add_circle_outline</mat-icon>
          <span>Created {{ this.sharedStateService.card.createdAt | date : "MMM d, y" }}</span>
        </div>
        }
        @if (this.sharedStateService.card.updatedAt) {
        <div class="info-item updated">
          <mat-icon class="info-icon">update</mat-icon>
          <span>Updated {{ this.sharedStateService.card.updatedAt | date : "MMM d, y" }}</span>
        </div>
        }
        @if (this.sharedStateService.card.resolvedAt) {
        <div class="info-item resolved">
          <mat-icon class="info-icon">check_circle_outline</mat-icon>
          <span>Resolved {{ this.sharedStateService.card.resolvedAt | date : "MMM d, y" }}</span>
        </div>
        }
        
           
        
      </div>
      }
      <div class="top">
              <!-- {{ boardForm.value.participants | json}} -->
        <mat-form-field class="full-width" appearance="outline" style="flex: 1; --mdc-outlined-text-field-container-shape: 8px;">
          <mat-label>Name</mat-label>

          <input formControlName="name" [readonly]="fileUploaded" matInput placeholder="" (blur)="onNameBlur()" />
        </mat-form-field>
        @if (sharedStateService.board?.environments?.length) {
        <app-custom-dropdown
          class="env-top"
          [items]="sharedStateService.board.environments!"
          formControlName="environment"
          placeholder="Select environment"
          [showNone]="true"
          label="Environment"
        ></app-custom-dropdown>
        }
        @if (sharedStateService.board?.modules?.length) {
        <app-custom-dropdown
          class="env-top"
          [items]="sharedStateService.board.modules!"
          formControlName="module"
          placeholder="Select module"
          [showNone]="true"
          label="Module"
        ></app-custom-dropdown>
        }
        @if (repoComponentTypes.length) {
        <app-custom-dropdown
          class="env-top"
          [items]="repoComponentTypes"
          formControlName="component"
          placeholder="Select component"
          [showNone]="true"
          label="Component"
        ></app-custom-dropdown>
        }
      </div>
      <div class="bottom">
        <div class="left">
          @if (boardForm.valid) {
           
          <app-attachments       
            formControlName="files">
          </app-attachments>
          }
          <div class="quil">
          
            <app-html-editor
              formControlName="description"
              [uploadFolder]="uploadFolder"
              [codes]="codes"
              [boardId]="sharedStateService.board?.key"
              (fileAdded)="fileAdded($event)"
              (imageZoom)="imageZoom.emit($event)">
            </app-html-editor>

        
          </div>
          <!-- <div class="loader" *ngIf="!editMode && boardForm.invalid">
            <img src="assets/img/skeleton_loader.svg" alt="">
          </div> -->
        </div>
        <div class="right">
          <div class="body">
            <mat-accordion>
              <!-- Status & Priority -->
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-icon *ngIf="boardForm.get('assignedToRole')?.errors || boardForm.get('assignedTo')?.errors || boardForm.get('lane')?.errors || boardForm.get('priority')?.errors" 
                  class="error-icon" color="warn">error</mat-icon>
                  <mat-panel-title>Assignment & Status</mat-panel-title>
            
                </mat-expansion-panel-header>

                <app-custom-dropdown
                  [items]="sharedStateService.users"
                  formControlName="assignedTo"
                  [showNone]="true"
                  placeholder="Select an item"
                  label="Assigned to"
                  [valueField]="'key'"
                  [displayField]="'name'"
                ></app-custom-dropdown>
                
                @if (boardForm.get('assignedTo')?.value && selectedUserRoles.length > 1) {
                <app-custom-dropdown
                  [items]="selectedUserRoles"
                  formControlName="assignedToRole"
                  [allowNull]="true"
                  placeholder="Select a role"
                  label="User Role"
                ></app-custom-dropdown>
                }
                
                @if (!settingData) {
                <app-custom-dropdown
                  [items]="sharedStateService.board.lanes"
                  formControlName="lane"
                  placeholder="Select a status"
                  label="Status"
                  [valueField]="'key'"
                  [displayField]="'name'"
                ></app-custom-dropdown>
                } 

          
                <app-custom-dropdown
                  [items]="sharedStateService.priorities"
                  formControlName="priority"
                  placeholder="Select a priority"
                  label="Priority"
                  [valueField]="'value'"
                  [displayField]="'label'"
              
                ></app-custom-dropdown>

                <app-custom-dropdown
                [items]="sharedStateService.users"
                formControlName="reporter"
                placeholder="Select a reporter"
                [showNone]="true"
                label="Reporter"
                [valueField]="'key'"
                [displayField]="'name'"
              ></app-custom-dropdown>

                <app-custom-dropdown
                  [items]="sharedStateService.types"
                  formControlName="type"
                  placeholder="Select a card type"
                  label="Card Type"
                ></app-custom-dropdown>

              </mat-expansion-panel>

              <!-- Dates & Planning -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Dates & Planning</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-form-field>
                  <mat-label>Due date</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="dueDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                
                <app-custom-dropdown
                  [items]="['1','2','3','5','8','13','21','34']"
                  formControlName="storyPoints"
                  placeholder="Select story points"
                  label="Story points"
                ></app-custom-dropdown>
              </mat-expansion-panel>

              <!-- Classification -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Classification</mat-panel-title>
                </mat-expansion-panel-header>
                
                <app-custom-dropdown
                  [items]="epics"
                  formControlName="epic"
                  placeholder="Select an epic"
                  [showNone]="true"
                  label="Epic"
                  [valueField]="'name'"
                  [displayField]="'name'"
                ></app-custom-dropdown>
<!--                 
                <app-custom-dropdown
                  [items]="sharedStateService.parts"
                  formControlName="part"
                  placeholder="Select a part"
                  label="Part"
                ></app-custom-dropdown>
                 -->
                <app-tag-manager
                  [tagKey]="this.sharedStateService.board.key"
                  formControlName="labels"
                  [label]="'Labels'"
                ></app-tag-manager>
                

                <app-custom-dropdown
                  [items]="sharedStateService.dors"
                  formControlName="dor"
                  placeholder="Select platforms"
                  label="Platforms"
                  [multiple]="true"
                ></app-custom-dropdown>
                
                <app-custom-dropdown
                  [items]="repositoryComponentTypes"
                  formControlName="repositoryComponents"
                  placeholder="Select repository components"
                  label="Repository Components"
                  [multiple]="true"
                  [valueField]="'value'"
                  [displayField]="'label'"
                ></app-custom-dropdown>

              </mat-expansion-panel>

              <!-- Links & References -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Links & References</mat-panel-title>
                </mat-expansion-panel-header>
                @if (sharedStateService.filteredCards) {
                <mat-form-field class="parent">
                  @if (parentItem) {
                  <mat-icon class="parent-icon" (click)="selectParent()">
                    open_in_new
                  </mat-icon>
                  }
                  <input matInput placeholder="Parent Card" formControlName="parentTmp" [matAutocomplete]="auto" />
                  <mat-autocomplete (optionSelected)="selectItem($event.option.value)" #auto="matAutocomplete">
                    @for (item of sharedStateService.filteredCards; track item) {
                    <mat-option [value]="item">
                      {{ item.name }}
                    </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                }
                <app-link-input label="Design link" formControlName="designLink"></app-link-input>
                <app-link-input label="Test Link" formControlName="testLink"></app-link-input>
              </mat-expansion-panel>

            </mat-accordion>
          </div>
        </div>
      </div>

      <!-- Related Cards Section -->
      @if (editMode && children && children.length > 0) {
      <div class="related-cards-section">
        <h3 class="section-title">Related cards</h3>
        <mat-chip-listbox aria-label="Related cards selection" (change)="selectChildItem($event)">
          @for (item of children; track item) {
          <mat-chip-option class="chip" [value]="item" [color]="item.status == 'done' ? 'accent' : 'warn'">
            {{ item.name }}
            <mat-icon class="close-icon" (click)="removeItem(item)">close</mat-icon>
          </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      }

      <!-- Comments Section -->
      <div class="comments-section">
        <h3 class="section-title">Comments</h3>
            <app-comments
              [cardKey]="boardForm.controls['key'].value"
              [boardKey]="data.board.key" 
              [boardName]="data.board.name"
              [cardName]="boardForm.controls['name'].value"
              [uploadFolder]="'uploads/comments/' + boardForm.controls['key'].value"
              [codes]="codes">
            </app-comments>
          </div>
    </div>
  </form>
  }
</div>
<div mat-dialog-actions class="buttons" align="end" >
  <div class="left">
    <button *ngIf="boardForm.value.key" mat-button (click)="addChild('Issue')" color="accent" mat-raised-button cdkFocusInitial extended
      [disabled]="boardForm.invalid">
      <mat-icon>add</mat-icon> Issue
    </button>
    <button *ngIf="boardForm.value.key" mat-button (click)="addChild('Enhancement')" color="secondary" mat-raised-button cdkFocusInitial extended
      [disabled]="boardForm.invalid">
      <mat-icon>add</mat-icon> Enhancement
    </button>

    @if (openTimeSheet) {
    <button mat-button (click)="stopTimer()" color="warn" mat-raised-button cdkFocusInitial>
      <mat-icon>timer</mat-icon>
      Stop Timer
    </button>
    } @else {
    <button mat-button (click)="startTimer()" color="primary" mat-raised-button cdkFocusInitial [disabled]="pauseSave">
      <mat-icon>timer</mat-icon>
      Start Timer
    </button>
    }
  </div>

  <div class="right">


    <app-loading-button 
      title="save" 
      color="primary" 
      variant="raised" 
      [loading]="saving"
      [disabled]="pauseSave || boardForm.invalid"
      (buttonClick)="save(true)">
      <mat-icon>save</mat-icon> <mat-icon>close</mat-icon> Save and Close
    </app-loading-button>
  </div>
</div>